import React from 'react'
import PropTypes from 'prop-types';
import theme from './ErrorBox.scss'
import errorImg from './i_error.png';
import {extractGroupErrors} from 'validation'
import {getMessage as msg} from 'MessageBundle'

export default class ErrorBox extends React.Component {

    errorsList = (errorMessages) => {
        return errorMessages.map((item, index) => {
            return (
                <li key={index}>
                    <img src={errorImg} alt=" " role="presentation"/>
                    <span>{item}</span>
                </li>
            )
        });
    };

    errorBox = (errorMessages) => {
        return (
            <div className={theme.blcError}>
                <h3 id={this.props.id} tabindex="0">{msg('errorBox.header')}</h3>
                <ul>
                    {this.errorsList(errorMessages)}
                </ul>
            </div>
        )
    };

    render() {
        const errorMessages = extractGroupErrors(this.props.errorMessages, this.props.groups);
        const errorBox = errorMessages.length > 0 ? this.errorBox(errorMessages) : null;
        return (
            errorBox
        );
    }
}

ErrorBox.propTypes = {
    messages: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/common/ErrorBox/index.js